import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const buyers = [{
  name: 'Mariana',
  city: 'Buenos Aires'
}, {
  name: 'Soledad',
  city: 'Córdoba'
}, {
  name: 'Paula',
  city: 'Rosario'
}, {
  name: 'Daniela',
  city: 'Mendoza'
}, {
  name: 'Florencia',
  city: 'La Plata'
}, {
  name: 'Romina',
  city: 'Salta'
}, {
  name: 'Gabriela',
  city: 'Tucumán'
}, {
  name: 'Andrea',
  city: 'Mar del Plata'
}, {
  name: 'Natalia',
  city: 'Santa Fe'
}, {
  name: 'Cecilia',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showPopup = () => {
    // Pick a random buyer
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 8-12 seconds
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-273">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 max-w-xs flex items-center gap-3" data-id="element-274">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-275">
            <CheckIcon className="w-5 h-5 text-green-600" data-id="element-276" />
          </div>
          <div data-id="element-277">
            <p className="text-sm text-gray-800 font-medium" data-id="element-278">
              <span className="font-bold" data-id="element-279">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city} acaba de comprar el Pack Efemérides Listas
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-280">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}